// import { faker } from '@faker-js/faker';
import dayjs from 'dayjs';

const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);

export const generateInstitute = (page?: number, pageSize?: number): any => {
  const numArray = Array(pageSize).fill(0);
  const response: any = {
    result: numArray.map((_, idx): any => {
      return {
        uuid: '',
        user: '',
        institute_name: '',
        address: '',
        zilla: '',
        upazilla: '',
        union: '',
        latitude: '',
        longitude: '',
        images: [
          {
            id: '',
            image: '',
            institute: '',
          },
        ],
        screenshots: [
          {
            id: '',
            image: '',
            institute: '',
          },
        ],
        is_done: true,
        is_verify: true,
        children: [
          {
            id: '',
            image: '',
            institute: '',
          },
        ],
      };
    }),
  };

  return response;
};
